export default __webpack_public_path__ + "static/media/toto.edcc1113.jpg";